import axios from "axios";

export class LocalFileService {
    get(filename) {
        return axios.get(`assets/data/${filename}.json`);
    }
}
